import React from 'react';

// Privacy Policy page component
const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              getphotoshoot.ai ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered jewelry photography service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We collect personal information that you provide directly to us, including:</p>
            <ul>
              <li>Name and email address (when you register via Google OAuth)</li>
              <li>Profile picture (from your Google account)</li>
              <li>Account credentials and preferences</li>
            </ul>

            <h3>2.2 Usage Information</h3>
            <p>We automatically collect certain information about your use of the Service:</p>
            <ul>
              <li>Images you upload for processing</li>
              <li>Generated images created through the Service</li>
              <li>Usage statistics and analytics</li>
              <li>Device information and browser type</li>
              <li>IP address and location data</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve the Service</li>
              <li>Process your image generation requests</li>
              <li>Manage your account and credits</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Monitor and analyze usage patterns</li>
              <li>Detect, prevent, and address technical issues</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Data Storage</h2>
            <p>
              Your images may be stored on our servers or third-party cloud storage services (such as AWS S3) based on your account settings. Original uploaded images and generated images are stored securely. You can request deletion of your images at any time by contacting support.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Third-Party Services</h2>
            <p>
              We use third-party services that may collect information used to identify you:
            </p>
            <ul>
              <li><strong>Google OAuth:</strong> For authentication, we integrate with Google's OAuth service. Review Google's Privacy Policy for information on how they handle your data.</li>
              <li><strong>Cloud Storage:</strong> We may use cloud storage providers (e.g., AWS S3) to store your images securely.</li>
              <li><strong>Analytics:</strong> We may use analytics services to understand how users interact with our Service.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your account and data</li>
              <li>Export your data</li>
              <li>Opt-out of certain communications</li>
            </ul>
            <p>
              To exercise these rights, please contact us through the Service's support channels.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Data Retention</h2>
            <p>
              We retain your personal information and images for as long as your account is active or as needed to provide the Service. We may retain certain information for longer periods as required by law or for legitimate business purposes.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Children's Privacy</h2>
            <p>
              Our Service is not intended for users under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Changes to Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us through the Service's support channels.
            </p>
          </section>
        </div>

        <div className="privacy-footer">
          <button className="privacy-back-btn" onClick={() => window.history.back()}>
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

